import { render } from "./StartAssessment.vue?vue&type=template&id=ccf99f8a"
import script from "./StartAssessment.vue?vue&type=script&lang=js"
export * from "./StartAssessment.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__